module.exports = __webpack_public_path__ + "img/boky_08_cervena.d786f3ba.png";